import el from "@cypherpotato/el";
import { api } from "../../api";
import { Card, CardContent, CardGrid, CardHeader } from "../../components/card";
import { Dashboard, DashboardTitle } from "../../components/dashboard";
import { Section } from "../../components/layout";
import { MutedText } from "../../components/text";
import { runOperation } from "../../ui/operation";

export default function () {

    const dashboard = el.state.create(null);

    runOperation(null, async () => {
        const result = await api.getJson("/api/v1/dashboard");
        dashboard.value = result.data;
    });

    return el.state.listening([dashboard], () =>
        Dashboard(
            DashboardTitle("Dashboard", "Manage your AI gateways, RAG collections and chat clients."),
            Section(
                CardGrid(
                    {
                        classList: ["span"]
                    },
                    dashboard.value?.cards.map(card =>
                        Card(
                            CardHeader(card.topLabel),
                            CardContent(
                                {
                                    classList: ["dashboard-card-content"]
                                },
                                el("h3", card.headingLabel)
                            )
                        )
                    ) || [
                        Card(
                            CardHeader("Loading"),
                            CardContent(MutedText("Fetching operational counters..."))
                        )
                    ]
                )
            )
        )
    )
}
